import type { LegJson, LegSummaryJson } from '@this/src/domain/select_repository';
import type Segment from '@this/src/domain/transit/segment';

/**
 * 航空便の出発地・到着地情報を抽出
 */
export const extractAirLegInfo = (legSummaries: LegSummaryJson[] | null) => {
  if (!legSummaries || !Array.isArray(legSummaries)) {
    return {
      fromName: '',
      fromTime: '',
      toName: '',
      toTime: ''
    };
  }

  const airLeg = legSummaries.find(leg => leg.type === 'air');
  return {
    fromName: airLeg?.from.name || '',
    fromTime: airLeg?.from.time || '',
    toName: airLeg?.to.name || '',
    toTime: airLeg?.to.time || ''
  };
};

/**
 * 複数の交通手段から総合的な路線情報を抽出
 */
export const extractNewLegInfo = (legSummaries: LegSummaryJson[]) => {
  const typeOrder = ['before', 'jr', 'after'];

  return typeOrder.reduce(
    (result, targetType) => {
      const targetLeg = legSummaries.find(leg => leg.type === targetType);
      if (!targetLeg) return result;

      if (result.fromTime === '' && targetLeg.from.time) {
        result.fromName = targetLeg.from.name;
        result.fromTime = targetLeg.from.time;
      }

      if (targetLeg.to.time) {
        result.toName = targetLeg.to.name;
        result.toTime = targetLeg.to.time;
      }

      if (result.name === '' && targetLeg.name) {
        result.name = targetLeg.name;
      }

      return result;
    },
    {
      fromName: '',
      fromTime: '',
      toName: '',
      toTime: '',
      name: ''
    }
  );
};

export const calculateTotalPrice = (legSummaries: LegSummaryJson[]) => {
  return legSummaries.reduce((total, leg) => total + (leg.price || 0), 0);
};

export const combineAllIndexes = (legSummaries: LegSummaryJson[]) => {
  return legSummaries.reduce((allIndexes, leg) => allIndexes.concat(leg.indexes), [] as string[]);
};

// これはutilsではなくて一般的な関数に移してもいいかもしれない
export const generateNewIndexes = (lastIndex: string, count: number) => {
  const startIndex = Number(lastIndex) + 1;
  return Array.from({ length: count }, (_, i) => String(startIndex + i));
};

export const findLegSummaryIndex = (legSummaries: LegSummaryJson[], targetType: string) => {
  return legSummaries.findIndex(leg => leg.type === targetType);
};

export const findLegSummaryByType = (segments: Segment[], targetType: string): LegSummaryJson | null => {
  return segments?.[0]?.leg_summaries?.find(leg => leg.type === targetType) || null;
};

export const getAirOnlyLegs = (segments: Segment[]): LegJson[] => {
  const airSummary = findLegSummaryByType(segments, 'air');
  if (!airSummary) return [];
  return airSummary.indexes.map(index => segments[0].legs[Number(index) - 1]);
};
